"use strict";

var ComponentInterpolator = require("../ComponentInterpolator");

var extend = function extend(I18n) {
  I18n.ComponentInterpolator = ComponentInterpolator;
  return I18n;
};

module.exports = extend;


//////////////////
// WEBPACK FOOTER
// ./node_modules/preact-i18nline/dist/extensions/i18n_js.js
// module id = 205
// module chunks = 3